import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Icon from "@mdi/react";
import { mdiPostOutline, mdiBadgeAccountHorizontalOutline } from "@mdi/js";
import { TiMessages } from "react-icons/ti";
import { PiNotebookLight } from "react-icons/pi";
import AboutItem from "./AboutItem";
import useGetWindowSize from "hooks/useGetWindowSize";
import DirectoryExample from "./LandingPageItems/DirectoryExample";
import { TfiAnnouncement } from "react-icons/tfi";
import { BiDonateHeart } from "react-icons/bi";
import Posts from "./LandingPageItems/Posts";
import GivingExample from "./LandingPageItems/GivingExample";
import EventsExample from "./LandingPageItems/EventsExample";
import { GrMultimedia } from "react-icons/gr";
import { VscFeedback } from "react-icons/vsc";
import { BsCalendar2Event } from "react-icons/bs";
import { IoDocumentsOutline } from "react-icons/io5";
import { RiBarChartBoxLine } from "react-icons/ri";
import { TbMessage2Question } from "react-icons/tb";
import { LuStore } from "react-icons/lu";
import { useTranslation } from "react-i18next";

function About() {
  const { t } = useTranslation("marketing");
  const [width, height] = useGetWindowSize();
  const [iconSize, setIconSize] = useState(4);

  useEffect(() => {
    if (width < 768) {
      setIconSize(2);
    } else {
      setIconSize(4);
    }
  }, [width]);

  return (
    <PRYS>
      <AboutPrayselyContainer id="learn-more">
        <AboutPraysely>
          <AboutItem
            backgroundColorImage={"#c2c9b3"}
            backgroundColorInfo={"#3d472b"}
            reverseRow={false}
            iconComponent={<Icon path={mdiPostOutline} size={iconSize} />}
            itemName={t("features.posts.name")}
            h3Name={t("features.posts.title")}
            userInfo={t("features.posts.body")}
            churchInfo={t("features.posts.body")}
            paragraph={t("features.posts.summary")}
            imagePath={"/img/post.png"}
            divComponent={<Posts />}
          />

          <AboutItem
            backgroundColorImage={"#425f10"}
            backgroundColorInfo={"#92da17"}
            reverseRow={true}
            iconComponent={<BiDonateHeart fontSize={65} />}
            itemName={t("features.giving.name")}
            h3Name={t("features.giving.title")}
            userInfo={t("features.giving.memberBody")}
            churchInfo={t("features.giving.churchBody")}
            paragraph={t("features.giving.summary")}
            imagePath={"/img/give.png"}
            divComponent={<GivingExample />}
          />

          <AboutItem
            backgroundColorImage={"#eeeeee"}
            backgroundColorInfo={"#6f952e"}
            reverseRow={false}
            iconComponent={
              <Icon path={mdiBadgeAccountHorizontalOutline} size={iconSize} />
            }
            itemName={t("features.directory.name")}
            h3Name={t("features.directory.title")}
            userInfo={t("features.directory.body")}
            churchInfo={t("features.directory.body")}
            paragraph={t("features.directory.summary")}
            imagePath={"/img/directory.jpeg"}
            divComponent={<DirectoryExample />}
          />

          <AboutItem
            backgroundColorImage={"#e3e3e3"}
            backgroundColorInfo={"#425f10"}
            reverseRow={true}
            iconComponent={<BsCalendar2Event size={70} />}
            itemName={t("features.events.name")}
            h3Name={t("features.events.title")}
            churchInfo={t("features.events.body")}
            userInfo={t("features.events.body")}
            paragraph={t("features.events.summary")}
            imagePath={"/img/event.png"}
            divComponent={<EventsExample />}
          />
        </AboutPraysely>
        <MoreFeaturesWrap>
          <MoreFeatures>
            <FeatureItem>
              <FeatureIconWrap>
                <RiBarChartBoxLine fontSize={70} />
              </FeatureIconWrap>
              <FeatureItemName>{t("more.polls.title")}</FeatureItemName>
              <FeatureItemDescription>
                {t("more.polls.body")}
              </FeatureItemDescription>
            </FeatureItem>
            <FeatureItem>
              <FeatureIconWrap>
                <TiMessages fontSize={70} />
              </FeatureIconWrap>
              <FeatureItemName>{t("more.messaging.title")}</FeatureItemName>
              <FeatureItemDescription>
                {t("more.messaging.body")}
              </FeatureItemDescription>
            </FeatureItem>
            <FeatureItem>
              <FeatureIconWrap>
                <PiNotebookLight fontSize={70} />
              </FeatureIconWrap>
              <FeatureItemName>{t("more.bulletin.title")}</FeatureItemName>
              <FeatureItemDescription>
                {t("more.bulletin.body")}
              </FeatureItemDescription>
            </FeatureItem>
            <FeatureItem>
              <FeatureIconWrap>
                <TfiAnnouncement fontSize={70} />
              </FeatureIconWrap>
              <FeatureItemName>{t("more.announcements.title")}</FeatureItemName>
              <FeatureItemDescription>
                {t("more.announcements.body")}
              </FeatureItemDescription>
            </FeatureItem>
            <FeatureItem>
              <FeatureIconWrap>
                <GrMultimedia fontSize={70} />
              </FeatureIconWrap>
              <FeatureItemName>{t("more.media.title")}</FeatureItemName>
              <FeatureItemDescription>
                {t("more.media.body")}
              </FeatureItemDescription>
            </FeatureItem>
            <FeatureItem>
              <FeatureIconWrap>
                <IoDocumentsOutline fontSize={70} />
              </FeatureIconWrap>
              <FeatureItemName>{t("more.files.title")}</FeatureItemName>
              <FeatureItemDescription>
                {t("more.files.body")}
              </FeatureItemDescription>
            </FeatureItem>
            <FeatureItem>
              <FeatureIconWrap>
                <VscFeedback fontSize={70} />
              </FeatureIconWrap>
              <FeatureItemName>{t("more.feedback.title")}</FeatureItemName>
              <FeatureItemDescription>
                {t("more.feedback.body")}
              </FeatureItemDescription>
            </FeatureItem>
            <FeatureItem
              style={{
                position: "relative",
              }}
            >
              <FeatureIconWrap>
                <TbMessage2Question fontSize={70} />
              </FeatureIconWrap>
              <FeatureItemName>{t("more.qna.title")}</FeatureItemName>
              <FeatureItemDescription>
                {t("more.qna.body")}
              </FeatureItemDescription>
            </FeatureItem>
            <FeatureItem
              style={{
                position: "relative",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100px",
                  height: "40px",
                  backgroundColor: "var(--themeColor)",
                  borderRadius: "10px",
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  fontSize: "12px",
                  color: "white",
                }}
              >
                <span>{t("comingSoon")}</span>
              </div>
              <FeatureIconWrap>
                <LuStore fontSize={70} />
              </FeatureIconWrap>
              <FeatureItemName>{t("more.marketplace.title")}</FeatureItemName>
              <FeatureItemDescription>
                {t("more.marketplace.body")}
              </FeatureItemDescription>
            </FeatureItem>
          </MoreFeatures>
        </MoreFeaturesWrap>
      </AboutPrayselyContainer>
    </PRYS>
  );
}

const FeatureItemDescription = styled.p`
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    sans-serif;
  font-weight: 400;
  color: rgba(245, 245, 240, 0.7);
  width: 100%;
  text-align: left;
  font-size: 14px;
  line-height: 1.6;
  margin: 12px 0 0;
  letter-spacing: -0.005em;
  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

const MoreFeaturesWrap = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 40px 120px;
  background: transparent;
  @media (max-width: 768px) {
    padding: 40px 16px 60px;
  }
`;

const MoreFeatures = styled.div`
  width: 100%;
  max-width: 1280px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  align-items: stretch;
  background-color: transparent;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 700px) {
    grid-template-columns: 1fr;
    gap: 14px;
  }
`;

const FeatureItem = styled.div`
  width: 100%;
  min-height: 260px;
  padding: 28px;
  border-radius: 20px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.05) 0%,
    rgba(255, 255, 255, 0.02) 100%
  );
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.04) inset;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  transition:
    transform 0.3s ease,
    border-color 0.3s ease,
    background 0.3s ease;
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    sans-serif;

  @media (max-width: 768px) {
    padding: 22px;
  }

  &:hover {
    transform: translateY(-4px);
    border-color: rgba(255, 255, 255, 0.22);
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.08) 0%,
      rgba(255, 255, 255, 0.03) 100%
    );
  }
`;

const FeatureItemName = styled.h3`
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    sans-serif;
  font-weight: 600;
  font-size: 19px;
  line-height: 1.3;
  letter-spacing: -0.02em;
  color: #f5f5f0;
  width: 100%;
  margin: 18px 0 0;
  @media (max-width: 768px) {
    font-size: 17px;
  }
`;

const FeatureIconWrap = styled.div`
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: linear-gradient(
    135deg,
    rgba(140, 184, 58, 0.25) 0%,
    rgba(111, 149, 46, 0.15) 100%
  );
  border: 1px solid rgba(181, 214, 113, 0.25);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #c9d4a8;

  svg {
    width: 26px;
    height: 26px;
    font-size: 26px;
  }
`;

const PRYS = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background:
    radial-gradient(
      60% 40% at 50% 0%,
      rgba(111, 149, 46, 0.25) 0%,
      transparent 70%
    ),
    linear-gradient(180deg, #14180b 0%, #0f1108 100%);
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    sans-serif;
`;

const AboutPrayselyContainer = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 1500px;
`;

const AboutPraysely = styled.div`
  height: fit-content;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: transparent;
  color: #f5f5f0;
  padding: 80px 0 40px;
  gap: 40px;

  @media (max-width: 768px) {
    padding: 40px 0 20px;
    gap: 20px;
  }
`;

export default About;
